/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  path {
    fill: inherit;
  }
  path.none {
    fill: none !important;
  }
`

export default function ChargeIco() {
  return (
    <Fragment>
      <svg xmlns="http://www.w3.org/2000/svg" width="44.64" height="44.64" viewBox="0 0 44.64 44.64" css={Color}>
        <g id="그룹_4304" data-name="그룹 4304" transform="translate(-144.536 -277.594)">
          <g id="그룹_4285" data-name="그룹 4285" transform="translate(1.109 1.941)">
            <path id="패스_4348" data-name="패스 4348" d="M170.772,293.285a4,4,0,0,0-1.423-2.716,4.2,4.2,0,0,0-2.991-1.054,4.954,4.954,0,0,0-3.368.878,3.109,3.109,0,0,0-1.122,2.281,2.465,2.465,0,0,0,.935,1.755,16.541,16.541,0,0,0,5.612,2.632,12.75,12.75,0,0,1,4.865,2.458,5.5,5.5,0,0,1,1.682,4.213,5.575,5.575,0,0,1-1.868,4.213,11.1,11.1,0,0,1-13.478.35,9.071,9.071,0,0,1-2.463-6.517c.143-2.112,3.573-2.232,3.585,0a5.786,5.786,0,0,0,9.355,4.236,3.266,3.266,0,0,0,1.122-2.458,2.973,2.973,0,0,0-1.122-2.106,12.339,12.339,0,0,0-4.3-2.106,18.442,18.442,0,0,1-6.175-2.983,5.085,5.085,0,0,1-1.684-3.859,5.715,5.715,0,0,1,2.058-4.213,9.035,9.035,0,0,1,6.365-1.93,8.406,8.406,0,0,1,5.988,2.106,5.732,5.732,0,0,1,1.9,4.76C174.14,294.944,171.01,294.751,170.772,293.285Z" transform="translate(0 -0.434)" fill="#20252d" />
            <path id="패스_4337" data-name="패스 4337" d="M166.943,313.6c-.866,0-1.567-.962-1.567-2.15V284.562c0-1.189.7-2.15,1.567-2.15s1.567.962,1.567,2.15v26.889C168.509,312.64,167.807,313.6,166.943,313.6Z" transform="translate(-0.911)" fill="#20252d" />
          </g>
          <g id="패스_4400" data-name="패스 4400">
            <path className="none" id="패스_4408" data-name="패스 4408" d="M166.856,277.594a22.32,22.32,0,1,1-22.32,22.32,22.32,22.32,0,0,1,22.32-22.32Z" fill="none" />
            <path id="패스_4409" data-name="패스 4409" d="M166.856,280.594a19.319,19.319,0,1,0,13.661,5.659,19.2,19.2,0,0,0-13.661-5.659m0-3a22.32,22.32,0,1,1-22.32,22.32A22.319,22.319,0,0,1,166.856,277.594Z" fill="#20252d" />
          </g>
        </g>
      </svg>

    </Fragment >
  )
}
